<template>
  <div>
 <!--
    A report showing all the vaccinations for a pharmacy
    Defaults to users default pharmacy except for admin users who can select the phamacies to report on

    Development log
        2021 - Intial development   Bruce Talbot
        04/04/2022  - modified export report to put attributes into separate columns
        13/06/2022  - modified to identify potential duplicates based on attribute 2
        13/12/2022  - modified to enable delete several vaccinations at the same time
                    - changed export to excel to use blobs to fix export size issue
        10/6/2025   - added functionality to enable patient name changes and stores to change/delete vaccinations in the current month
 -->     
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Vouchers By Pharmacy</h3>
        <div class="ReportsCriteria">
          <span>
            <label for="pharm-select">Pharmacy</label><br/>
            <div v-if="UserGroup === 'VoucherAdmin' || UserGroup === 'VoucherReporting'">
              <select id="pharm-select" v-model="SelectedPharmacy" class ="contractCustomer" @change="listVaccinations()" >
                  <option value="" selected disabled >Select Pharmacy</option>
                  <option value="All">All</option>
                  <option v-for="Pharmacy in sortedPharmacies"
                    :value="Pharmacy.code"
                    :key="Pharmacy.id"
                    >
                    {{Pharmacy.code}}
                  </option>
              </select>
            </div>
            <div v-else-if="UserPharmacies.length > 0">
              <select id="pharm-select" v-model="SelectedPharmacy" class ="contractCustomer" @change="listVaccinations()" >             
                  <option v-for="pharmacy in UserPharmacies"
                    :value="pharmacy"
                    :key="pharmacy"
                    >
                    {{pharmacy}}
                  </option>
              </select>
            </div>  
            <div v-else>
              <select id="pharm-select" v-model="SelectedPharmacy" class ="contractCustomer" @change="listVaccinations()" >             
                  <option
                    :value="SelectedPharmacy"
                    :key="SelectedPharmacy"
                    >
                    {{SelectedPharmacy}}
                  </option>
              </select>
            </div>
          </span>
          <span class="ReportsCriteriaDate ReportsCriteria">
            <label for="startdate">Start Date</label><br/>
            <input id="startdate" type="date"
              :value="fromDate && new Date(fromDate.getTime()-(fromDate.getTimezoneOffset()*60*1000)).toISOString().split('T')[0]"
              @input="UpdateDate('from', $event.target.valueAsDate)"
              @change="listVaccinations()"
              >
          </span>
          <span class="ReportsCriteriaDate ReportsCriteria">
            <label for="enddate">End Date</label><br/>
            <input id="enddate" type="date"
            :value="toDate && new Date(toDate.getTime()-(toDate.getTimezoneOffset()*60*1000)).toISOString().split('T')[0]"
            @input="UpdateDate('to', $event.target.valueAsDate)"
            @change="listVaccinations()">
          </span>
          <span class="ReportsCriteriaDate ReportsCriteria">
            <br/>
            <button @click="tableToExcel('VaccinationTable', 'Pharmacy Vaccinations', SelectedPharmacy)" class="ReportsExcel">
              <img src="@/assets/Excel32a.png" />
            </button>
          </span>

        </div>

        <div v-if="UserGroup === 'VoucherAdmin'">
          Potential Duplicates Only  <br /> <input type="checkbox" v-model="potentialDup" />
        </div>
        <div class="page-loader" v-if="!isloaded">
          <PageLoader />
        </div>
        <div v-else>
                                                                                                    <!-- 04/04/2022 start -->                      
          <table ref="tableDisp" id="VaccinationTable" class="Customer-table DisplayTable">
                                                                                                    <!-- 04/04/2022 end -->            
            <thead>
                <tr>
                  <th
                    v-if="currentSort == 'pharmacyCode'"
                    @click ="sort('pharmacyCode')"
                    :class="currentSortDir == 'asc' ? 'ReportsAscIcon ReportsPharmacyCode' :'ReportsDescIcon ReportsPharmacyCode'">
                    Pharmacy
                  </th>
                  <th v-else
                    @click ="sort('pharmacyCode')" class="ReportsPharmacyCode ReportsDisabledIcon">
                    Pharmacy
                  </th>
                  <th
                    v-if="currentSort == 'vaccinationDate'"
                    @click ="sort('vaccinationDate')"
                    :class="currentSortDir == 'asc' ? 'ReportsAscIcon ReportsDate' :'ReportsDescIcon ReportsDate'">
                    Date
                  </th>
                  <th v-else
                    @click ="sort('vaccinationDate')" class="ReportsDate ReportsDisabledIcon">
                    Date
                  </th>
                  <th class="ReportsPharmacyCode">Product</th>
                  <th
                    v-if="currentSort == 'patientName'"
                    @click ="sort('patientName')"
                    :class="currentSortDir == 'asc' ? 'ReportsAscIcon ReportsPatient' :'ReportsDescIcon ReportsPatient'">
                    Patient
                  </th>
                  <th v-else
                    @click ="sort('patientName')"  class="ReportsPatient ReportsDisabledIcon">
                    Patient
                  </th>
                  <th>Voucher Code</th>
                  <th class="ReportsPatient">Customer</th>
                  <th>Additional Information</th>
                  <th class="buttonCol"/>
                  <th v-if="UserGroup === 'VoucherAdmin'" class="buttonCol">
                      <button v-on:click="deleteMultipleVaccinations()" class="DeleteAll" title="Delete selected vaccinations">Delete Selected</button>
                    </th>            
                </tr>
              </thead>
              <tbody v-for= "(Vaccination, indexVaccination) in sortedVaccinations" :key="indexVaccination" class="ReportsTable">
                <tr v-if="new Date(Vaccination.vaccinationDate) >= new Date(fromDate)
                    && new Date(Vaccination.vaccinationDate) <= new Date(toDate)
                    && ((potentialDup && Vaccination.duplicate) || !potentialDup)"
                    :class="Vaccination.duplicate && UserGroup === 'VoucherAdmin' ? 'ReportsTable duplicate' :'ReportsTable'">
                  <td v-if="editingId == indexVaccination && UserGroup === 'VoucherAdmin'">
                    <select v-model="Vaccination.pharmacyCode" class="PharmacyDescription editable">
                      <option v-for="Pharmacy in sortedPharmacies"
                          v-bind:value="Pharmacy.code"
                          v-bind:key="Pharmacy.code"
                          >
                          {{Pharmacy.code}}
                      </option>
                    </select>
                  </td>
                  <td v-else class="PharmacyDescription ReportsCell-left">{{Vaccination.pharmacyCode}}</td>
 <!--
                    <td v-if="editingId == indexVaccination">
                    <input type="date"
                      v-model="Vaccination.vaccinationDate"
                      :class= "editable"
                    >
                  </td>
                  <td v-else class="ReportsCell-centre">{{Vaccination.vaccinationDate | VaccinationsDate}}</td>
 -->
                  <td class="ReportsCell-centre">{{Vaccination.vaccinationDate | VaccinationsDate}}</td>
                  <td class="ReportsCell-left">{{Vaccination.product}}<br /></td>
                  <td v-if="editingId == indexVaccination">
                        <input type="text"                     
                            class="editable ReportAttributesValue"
                            v-model="Vaccination.patientName"
                        >
                  </td>
                  <td v-else class="ReportsCell-left">{{Vaccination.patientName}}</td>
                  <td class="ReportsCell-centre">{{Vaccination.voucherCode}}</td>
                  <td class="ReportsCell-centre">{{Vaccination.customer}}</td>
                  <td>
                    <table class="ReportAttributes">
                      <tr v-for= "(customerAttribute, index) in Vaccination.customerAttributes" :key="index">
                        <td class="ReportAttributesName">{{customerAttribute.name}}:</td>
                        <td v-if="editingId == indexVaccination">
                          <input type="text"                     
                            class="editable ReportAttributesValue"
                            v-model="customerAttribute.value"
                          >
                        </td>
                        <td v-else class="ReportAttributesValue NoBorder">{{customerAttribute.value}}</td>
                     </tr>
                    </table>
                  </td>
                  <td v-if="UserGroup === 'VoucherAdmin'">
                    <span  v-if="editingId === null">
                      <button v-on:click="editItem(indexVaccination)" class="editbutton icon" title="Edit Vaccination"></button>
                      <button v-on:click="deleteVaccination(Vaccination.id, Vaccination.pharmacyCode, Vaccination.vaccinationDate, Vaccination.patientName)" class="deletebutton icon" title="Delete Vaccination"></button>
                    </span>
                    <span v-else-if="editingId === indexVaccination">
                      <span v-if="!VaccinationValid">
                        <button disabled class="savebutton icon btnDisabled" title="Not all data has been entered to save record"></button>
                      </span>
                      <span v-else>
                        <button v-on:click="updateVaccination(indexVaccination)" class="savebutton icon" title="Save"></button>
                      </span>
                        <button v-on:click="canceledit()" class="cancelbutton icon" title="Cancel"></button>
                    </span>
                  </td>
                  <td v-else-if="new Date(Vaccination.vaccinationDate) >= new Date(currentDate)">
                    <span  v-if="editingId === null">
                      <button v-on:click="editItem(indexVaccination)" class="editbutton icon" title="Edit Vaccination"></button>
                      <button v-on:click="deleteVaccination(Vaccination.id, Vaccination.pharmacyCode, Vaccination.vaccinationDate, Vaccination.patientName)" class="deletebutton icon" title="Delete Vaccination"></button>
                    </span>
                    <span v-else-if="editingId === indexVaccination">
                      <span v-if="!VaccinationValid">
                        <button disabled class="savebutton icon btnDisabled" title="Not all data has been entered to save record"></button>
                      </span>
                      <span v-else>
                        <button v-on:click="updateVaccination(indexVaccination)" class="savebutton icon" title="Save"></button>
                      </span>
                        <button v-on:click="canceledit()" class="cancelbutton icon" title="Cancel"></button>
                    </span>
                  </td>
                  <td v-else>
                      <button class="editbutton icon" hidden></button>
                      <button class="deletebutton icon" hidden></button>
                  </td>
                  <td v-if="UserGroup === 'VoucherAdmin'">
                    <input type="checkbox" id="deleteVoucher" @change="updateDeleteMe(indexVaccination)" />
                  </td>
                </tr>
              </tbody>
          </table>
            <div class="clearFormatting">
              <b>Total vaccinations {{TotalVaccinations}}</b>
            </div>
                                                                                                    <!-- 04/04/2022 start -->            
          <table ref="table" id="VaccinationTable" class="Customer-table DisplayTable ReportsHidden">
            <thead>
                <tr>
                  <th class="ReportsPharmacyCode">Pharmacy</th>
                  <th class="ReportsDate">Date</th>
                  <th class="ReportsPharmacyCode">Product</th>
                  <th class="ReportsPatient">Patient</th>
                  <th>Voucher Code</th>
                  <th>Customer</th>
                  <th v-if="UserGroup === 'VoucherAdmin'" class="ReportsPatient">Duplicate?</th>
                  <th>Attributes</th>
                </tr>
              </thead>
              <tbody v-for= "(Vaccination, indexVaccination) in sortedVaccinations" :key="indexVaccination" class="ReportsTable">
                <tr>
                  <td class="PharmacyDescription ReportsCell-left">{{Vaccination.pharmacyCode}}</td>
                  <td class="ReportsCell-centre">{{Vaccination.vaccinationDate | VaccinationsDate}}</td>
                  <td class="ReportsCell-left">{{Vaccination.product}}<br /></td>
                  <td class="ReportsCell-left">{{Vaccination.patientName}}</td>
                  <td class="ReportsCell-centre">{{Vaccination.voucherCode}}</td>
                  <td class="ReportsCell-centre">{{Vaccination.customer}}</td>
                  <td class="ReportsCell-left" v-if ="Vaccination.duplicate && UserGroup === 'VoucherAdmin'">{{Vaccination.duplicate}}</td>
                  <td v-else-if =  "UserGroup === 'VoucherAdmin'"></td>
                  <td v-for= "(customerAttribute, index) in Vaccination.customerAttributes" :key="index">{{customerAttribute.value}}</td>
                </tr>
              </tbody>
          </table> 
                                                                                                    <!-- 04/04/2022 end -->            
       </div>
    </div>
    <div>
      <button class='UserName' v-on:click="displayUserInfo()"></button>
    </div>
    <div v-if="message" class="errormessage">
      <table>
        <tr>
          <td>{{message}}</td>
        </tr>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { listPharmacys } from '../../graphql/queries';
import UserInfoStore from '../../app/user-info-store';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";
import { deleteVaccination } from '../../graphql/mutations';
import { updateVaccination} from '../../graphql/mutations';
import { listProducts } from '../../graphql/queries';
import PageLoader from "@/components/PageLoader";
import { getPharmacyUserByUserEmail } from '../../graphql/queries';
import { listContracts } from '../../graphql/queries';

export default {
  name: 'app',
  components:{
    RwvMenu,
    PageLoader,
  },
  async created() {
  // console.log('created ...');
  this.setDates();
  this.listPharmacies();
  await this.listProducts();
  await this.listContracts();
  if(UserInfoStore.state.userGroup != 'VoucherAdmin') {
    this.SelectedPharmacy = UserInfoStore.state.branchName
  }
 // else {this.SelectedPharmacy ='All'}
  this.getPharmacyUser(this.userEmail);
  if(UserInfoStore.state.userGroup != 'VoucherAdmin') {
    this.listVaccinations();
  }
  // console.log('created end');
},
  data() {
    return {
      Vaccinations: [],
//     VaccinationsDup: [],
      frozenVaccinations: [],
      Pharmacies: [],
      Products: [],
      Contracts: [],
      currentSort: 'vaccinationDate',
      currentSortDir: 'desc',
      pharmSort: 'code',
      UserGroup: UserInfoStore.state.userGroup,
      userEmail: UserInfoStore.state.userEmail.toLowerCase(),
      UserPharmacies: [],
      fromDate: '',
      toDate: '',
      SelectedPharmacy: '',
      message: '',
      editingId: null,
      currentDate:'',
      AllData: false,
      VaccinationValid: false,
      TotalVaccinations: 0,
      isloaded: true,
      potentialDup: false,
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    }
  },
  filters:{
    VaccinationsDate: (str) => {
      if (!str) { return '(n/a)'; }
      str = new Date(str);
      return ((str.getDate() < 10) ? '0' : '') + str.getDate()+ '-' + ((str.getMonth() < 9) ? '0' : '') + (str.getMonth() + 1) + '-'
         + str.getFullYear() + ' ' + ((str.getHours() < 10) ? '0' : '') + str.getHours() + ":" + ((str.getMinutes() < 10) ? '0' : '') + str.getMinutes();
      },
    },
  methods: {
    async listVaccinations(){
//     console.log('listVaccination ...');
      this.TotalVaccinations = 0;
      this.message = "";
      if (this.toDate < this.fromDate) {
        this.message = "End Date must be greater than or equal to Start Date"
      }
      else {
        if (this.SelectedPharmacy != ''){
          this.isloaded = false;
          try {
            if (this.SelectedPharmacy === "All"){
              this.Vaccinations = await commonFunctions.getAllVacinations(this.fromDate, this.toDate);
            }
            else { 
              this.Vaccinations = await commonFunctions.getVaccinationsPharmacy(this.SelectedPharmacy, this.fromDate, this.toDate)
            }
            for (var i=this.Vaccinations.length - 1; i>=0; i--) {
              this.Vaccinations[i].product = this.findObjectByKey(this.Products, 'id', this.Vaccinations[i].contract.productId).description;
              this.Vaccinations[i].duplicate = false;
              this.Vaccinations[i].customer = this.findObjectByKey(this.Contracts, 'id', this.Vaccinations[i].contractId).customer.name;
              this.Vaccinations[i].deleteMe = false;
            }  
            this.TotalVaccinations = this.sortedVaccinations.length; 
          if (this.UserGroup === 'VoucherAdmin'){
           this.Vaccinations =  commonFunctions.DupVaccinationCheck(this.Vaccinations) 
          }     
/* 
            this.VaccinationsDup = this.Vaccinations
            if (this.UserGroup === 'VoucherAdmin'){
              for ( i=0; i<this.Vaccinations.length; i++) {
                for (var j=0; j<this.Vaccinations.length; j++){
                  if (i !== j && this.Vaccinations[i].customerAttributes.length > 1 && this.VaccinationsDup[j].customerAttributes.length > 1){
                    if (this.Vaccinations[i].customerAttributes[1].value === this.VaccinationsDup[j].customerAttributes[1].value){
                      this.Vaccinations[i].duplicate = true
                    }
                  }
                }
              }
            }
*/
          }
          catch (error) {
            this.message = commonFunctions.displayError(error);
          }
          finally {
            this.isloaded = true;
          }
        }
      }
//       console.log('listVaccination end');
    },
    sort: function(s) {
      // console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },
    async listPharmacies() {
      // console.log('listPharmacies ...');
      var limit = 1000;
      try {
        const Pharmacies = await API.graphql({
          query: listPharmacys,
          variables: {limit: limit}
        });
        this.Pharmacies = Pharmacies.data.listPharmacys.items;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
 //      console.log('listPharmacies end ...');
    },

    async listProducts() {
      // console.log('getProducts ...')
      var limit = 1000;
      try {
        const products = await API.graphql({
          query: listProducts,
          variables: {limit: limit}
        });
        this.Products = products.data.listProducts.items;
        var i;
        for (i=0; i<this.Products.length; i++) {
          this.Products[i].price = this.Products[i].price.toFixed(2);
        }
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
      // console.log('getProducts end ...')
    },
    async listContracts() {
//       console.log('listContracts ...')
     try {
        var limit = 2000;
        const Contracts = await API.graphql({
        query: listContracts,
        variables: {limit: limit}
        });
        this.Contracts = Contracts.data.listContracts.items;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
//      console.log('listContracts end')      
    },
    async getPharmacyUser(userEmail) {
//       console.log('getPharmacyUser ...');
      try {
        var filter;
        var limit = 2000;
        filter = {enabled: {eq: true}};
        const User = await API.graphql({
          query: getPharmacyUserByUserEmail,
          variables: {userEmail: userEmail, filter: filter, limit: limit}
        });
        if(User.data.getPharmacyUserByUserEmail.items.length > 0) {
          for (var i=0; i < User.data.getPharmacyUserByUserEmail.items[0].pharmacyCodes.length; i++) {
            this.UserPharmacies[i] = User.data.getPharmacyUserByUserEmail.items[0].pharmacyCodes[i]
          }

          var valObj = this.UserPharmacies.includes(this.SelectedPharmacy)
          if (!valObj) {
            this.UserPharmacies.push(this.SelectedPharmacy)
          }
          this.UserPharmacies.sort();
        }
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
//      console.log('getPharmacyUser end');
   },
  displayUserInfo(){
      alert("User: " + this.userEmail + " Pharmacies: " + this.UserPharmacies)     
    },
  setDates() {
 //      console.log('setDates ...');
      var date1 = new Date();
      date1.setDate(1)
      date1.setHours(0,0,0,0);
      this.fromDate = date1;
      this.currentDate = date1;
      var date2 = new Date();
      var lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
      date2.setDate(lastDayOfMonth.getDate())
      date2.setHours(23,59,59,99);
      this.toDate = date2;
 //   console.log('setDates end');
    },
    UpdateDate(d, v){
      // console.log('UpdateDate ...');
      var date1 = new Date(v);
      if (d =='from'){
        date1.setHours(0,0,0,0);
        this.fromDate = date1;
      }
      else{
        date1.setHours(23,59,59,99)
        this.toDate = date1;
      }
      // console.log('UpdateDate end');
    },

    findObjectByKey: function(array, key, value) {
//      console.log("findObjectByKey .....")
      try {
        if(array.length > 0){
          for (var i = 0; i < array.length; i++) {
              if (array[i][key] === value) {
               return array[i];
              }
          }
        }
        return "not found";
      }
      catch (error) {
        console.log("error", error)
        this.message = commonFunctions.displayError(error);
      }

    },

    tableToExcel: function(table, name, ReportPharmacy){
//     console.log('tableToExcel ...', table);
      if (!table.nodeType) table = this.$refs.table
      var header = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Customer Details</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>'
      var dataTable = table.innerHTML
      var footer = "</table></body></html>";
      var tabla = header + dataTable + footer;
      var myBlob =  new Blob( [tabla] , {type:'application/vnd.ms-excel'});
      var url = window.URL.createObjectURL(myBlob);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = "VaccinationBypharmacy - " + ReportPharmacy + ".xls";
      a.click();
      setTimeout(function() {window.URL.revokeObjectURL(url);},0);
//      console.log('tableToExcel end');
 //     if (!table.nodeType) table = this.$refs.table
 //     var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
 //     window.location.href = this.uri + this.base64(this.format(this.template, ctx))
    },
                                                                 // set row in edit mode
    editItem(indexRow) {
      // console.log('editItem ...');
      this.editingId = indexRow
      this.AllData = true;
      this.VaccinationValid = true;
    },
                                                                    // Reset row to original values
    canceledit() {
      // console.log('Cancel Edit ...');
      this.resetVariables();
      this.editingId = null;
      this.listVaccinations();
      this.resetVariables();
      // console.log('Cancel Edit end');
    },
    resetVariables() {
      // console.log('reset variables ...');
      this.VaccinationValid = false;
      this.AllData = false;
      this.message = '';
      // console.log('reset variables end');
    },
                                                                    // Delete Vaccination
    async deleteVaccination(id, pharmacy, vaccinationDate, patientName) {
 //      console.log('deleteVaccination ...');
 //      console.log('id = ', id, 'indexRow ', indexRow);
      this.message = ""
      var dte = new Date(vaccinationDate);
      dte =  ((dte.getDate() < 10) ? '0' : '') + dte.getDate()+ '-' + ((dte.getMonth() < 9) ? '0' : '') + (dte.getMonth() + 1) + '-'
         + dte.getFullYear() + ' ' + ((dte.getHours() < 10) ? '0' : '') + dte.getHours() + ":" + ((dte.getMinutes() < 10) ? '0' : '') + dte.getMinutes();

      if(confirm("Do you really want to delete the vaccination for " + patientName + " on " + dte + " given at "+ pharmacy + "?")) {
        try {

          const Vacid = {id};
          await API.graphql({
            query: deleteVaccination,
            variables: {input: Vacid},
          });
          this.listVaccinations();
        }
        catch (error) {
 //         console.log(error)
          this.message = commonFunctions.displayError(error);
        }
      }
 //      console.log('deleteVaccination end ...');
    },
                                                                   // Delete Multiple Vaccinations at the same time
    async deleteMultipleVaccinations() {
//      console.log('deleteMultipleVaccinations ...');
      if(confirm("Do you really want to delete all the selected vaccinations ?")) {
        try {
          for(var i=0; i < this.sortedVaccinations.length; i++) {
            if (this.sortedVaccinations[i].deleteMe) {
              const id = this.sortedVaccinations[i].id;
              const Vacid = {id};
              await API.graphql({
                query: deleteVaccination,
                variables: {input: Vacid},
              });
            }
          }
          this.listVaccinations();
        }
        catch (error) {
 //         console.log(error)
          this.message = commonFunctions.displayError(error);
        }
      }
//      console.log('deleteMultipleVaccinations end');
    },                                                                  // Update Vaccination
    async updateVaccination(Rowid) {
 //     console.log('updateVaccination ...')
      var UpdateValues;
      var customerAttributes = [];
 //     console.log(Rowid, this.sortedVaccinations[Rowid])
      for(var i=0; i < this.sortedVaccinations[Rowid].customerAttributes.length; i++) {
          if (!this.sortedVaccinations[Rowid].customerAttributes[i].value) return;
          customerAttributes.push({
          name: this.sortedVaccinations[Rowid].customerAttributes[i].name,
          value: this.sortedVaccinations[Rowid].customerAttributes[i].value
        });
      }
 
      const lastUpdatedBy = this.userEmail;
      const id = this.sortedVaccinations[Rowid].id;
      const pharmacyCode = this.sortedVaccinations[Rowid].pharmacyCode;
      const patientName = this.sortedVaccinations[Rowid].patientName;
 //     const vaccinationDate = this.sortedVaccinations[Rowid].vaccinationDate;    
 //     console.log(customerAttributes)

      try {
            UpdateValues = {id, pharmacyCode, patientName, customerAttributes, lastUpdatedBy};
 //         UpdateValues = {id, pharmacyCode, customerAttributes, lastUpdatedBy, vaccinationDate};
 //         console.log(UpdateValues)
          await API.graphql({
             query: updateVaccination,
             variables: {input: UpdateValues},
           });
         }
      catch (error) {
          this.message = commonFunctions.displayError(error);
       }
      this.editingId = null;
      this.listVaccinations()
      this.resetVariables()
 //     console.log('updateVaccination end ...');
    },
  updateDeleteMe(Rowid) {
//    console.log('updateDeleteMe ...')
//    console.log(Rowid, this.sortedVaccinations[Rowid].deleteMe)
    if (this.sortedVaccinations[Rowid].deleteMe) {
      this.sortedVaccinations[Rowid].deleteMe = false;
    }
    else {
      this.sortedVaccinations[Rowid].deleteMe = true;
    }
//    console.log('updateDeleteMe end')
    }

  },
  computed: {
    sortedVaccinations: function() {
      // console.log('sortedVaccinations ...');
      if (this.editingId != null) {return this.frozenVaccinations}
      return this.Vaccinations.slice().sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] === null | a[this.currentSort] === undefined) return 1 * modifier;
        if(b[this.currentSort] === null | b[this.currentSort] === undefined) return -1 * modifier;
        if(a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
        if(a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return 1 * modifier;
        return 0;
      });
    },
    sortedPharmacies: function() {
    //  console.log('sortedPharmacies ...');
      return this.Pharmacies.slice().sort((a,b) => {
        if(a.code < b.code) return -1;
        if(a.code > b.code) return 1;
        return 0;
      });
    },
  },
  watch: {
    sortedVaccinations: {
      handler: function() {
        if (this.editingId === null) {
          this.frozenVaccinations = this.sortedVaccinations.slice()
        }
      }     
    }
  },
}
</script>
<style>

</style>
